import { useState } from "react";

/**
 * A number cell that keeps the typed text. Text that does not parse is passed up as NaN (so the template cannot be
 * saved, a set cannot be ticked) and the cell turns red; a value changed from outside (e.g. "+ Satz" copying) replaces the text.
 */
export function NumField(props: {
  label: string;
  value: number | undefined;
  mode: "decimal" | "numeric";
  parse(text: string): number | undefined;
  format(n: number | undefined): string;
  placeholder?: string;
  /** marked red too (a value needed to tick the set) */
  missing?: boolean;
  onChange(v: number | undefined): void;
}) {
  const [text, setText] = useState(() => props.format(props.value));
  const [seen, setSeen] = useState(props.value);
  if (!Object.is(seen, props.value)) {
    setSeen(props.value);
    if (!Object.is(props.parse(text), props.value)) setText(props.format(props.value));
  }
  const invalid = Number.isNaN(props.parse(text)) || !!props.missing;
  return (
    <input className={"field num" + (invalid ? " invalid" : "")} aria-label={props.label} aria-invalid={invalid}
      inputMode={props.mode} value={text} placeholder={props.placeholder}
      onChange={(e) => { setText(e.target.value); props.onChange(props.parse(e.target.value)); }} />
  );
}
